<template>
  <div>
    <div class="row">
      <!-- <div style="width: 100%; margin-left: 1rem; margin-right: 1rem">
        <a-tabs default-active-key="1" @change="changeTabSales">
          <a-tab-pane :key="1" tab="All Sales" />
          <a-tab-pane :key="2" tab="Webcommerce Sales" />
          <a-tab-pane :key="3" tab="Reseller Sales" />
        </a-tabs>
      </div> -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div style="width: 100%">
              <a-tabs :default-active-key="order_state" @change="changeTabStatus">
                <a-tab-pane key="all" tab="All" />
                <a-tab-pane key="draft,waiting_payment" tab="Waiting Payment" />
                <a-tab-pane key="new" tab="New" />
                <a-tab-pane key="on_process,confirmed,ready_to_pickup" tab="On Process" />
                <a-tab-pane key="sent" tab="Sent" />
                <a-tab-pane key="delivered" tab="Delivered" />
                <a-tab-pane key="completed" tab="Completed" />
                <a-tab-pane key="on_cancel_req,on_retour_req" tab="Cancel Request" />
                <a-tab-pane key="canceled,retoured,payment_expired,payment_unfinish,payment_declined" tab="Canceled" />
              </a-tabs>
            </div>

            <div class="row">
              <div class="col-12 mt-2">
                <a-input-search
                  placeholder="Order Number"
                  :value= valueSearch
                  @change="onSearch"
                  class="w-50"
                />
              </div>
            </div>
            <div class="row">
              <div class="mt-2 col-6">
                <a-range-picker @change="onSerachByDate" />
              </div>
              <div class="mt-2 col-6 text-right">
                <a-select
                  placeholder="Select Channels"
                  class="w-50"
                  default-value="all"
                  @change="handleChangeChannels"
                >
                  <a-select-option
                    v-for="channel in channels"
                    :key="channel.channel_id"
                    :value="channel.channel_id"
                  >
                    {{ channel.channel_title }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="card-body">
            <a-table
              :loading="isLoadingTable"
              :columns="columns"
              :pagination="pagination"
              :row-key="data => data.order_number"
              :data-source="salesOrders"
              @change="handleTableChange"
              :scroll="{ y: 450 }"
              :custom-row="(record) => ({
                on: {
                  click: showModalDetail(record.order_number)
                }
              })"
              class="order-table"
            >
              <div slot="order_number" slot-scope="text, record">
                <strong> {{ record.order_number }} </strong>
                <p> {{ changeDateFormat(record.created_at) }} </p>
              </div>
              <div slot="order_total" slot-scope="text, record">
                {{ Number(record.total_transaction) | currency}}
              </div>
              <div slot="order_state" slot-scope="text, record">
                <a-tag :color="colorStatus(record.order_state)">
                  {{ changeDisplayNameStatus(record.order_state) }}
                </a-tag>
              </div>
              <div slot="actions" slot-scope="text, record">
                <a-button @click="showModalDetail(record.order_number, record.order_state)"> Order Detail </a-button>
              </div>
              <div slot="customer_name" slot-scope="text, record">
                {{ record.ship_to }}
              </div>
              <div slot="shipment" slot-scope="text, record">
                {{ record.dest_city }}
              </div>
            </a-table>
          </div>
        </div>
      </div>
      <div class="vld-parent">
        <loading
          :active.sync="isLoadingOrders"
          :can-cancel="false"
          :is-full-page="true"
          :height="30"
          :width="30"
        ></loading>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from 'vue-loading-overlay'
import BaseURL from '@/services/axios'
// import Vue from 'vue'
// import { i18n } from '@/localization'

export default {
  components: {
    Loading,
  },
  data () {
    return {
      order_state: 'all',
      visible: false,
      modalPaymentExpired: false,
      valueSearch: null,
      position: {
        x: 0,
        y: 0,
      },
      form: this.$form.createForm(this),
      page: 1,
      limit: 20,
      timeout: 0,
      date: {
        from: null,
        to: null,
      },
      channels: [],
      channel_id: 'all',
    }
  },
  computed: {
    ...mapState('salesOrders', {
      isLoadingOrders: state => state.isLoadingOrders,
      salesOrders: state => state.salesOrders,
      orderDetail: state => state.orderDetail,
      columns: state => state.columns,
      pagination: state => state.pagination,
      isLoadingTable: state => state.isLoadingTable,
    }),
  },
  methods: {
    ...mapActions('salesOrders', [
      'GETORDERDETAIL',
      'GETSALESORDERS',
    ]),

    fethOrders () {
      const pager = { ...this.pagination }
      this.GETSALESORDERS({
        order_state: this.order_state === 'all' ? undefined : this.order_state,
        page: pager.current,
        q: this.valueSearch ? this.valueSearch : undefined,
        from: this.date.from ? this.date.from : undefined,
        to: this.date.to ? this.date.to : undefined,
        channel_id: this.channel_id === 'all' ? undefined : this.channel_id,
      })
    },

    ...mapMutations('salesOrders', [
      'SET_PAGINATION',
    ]),

    changeTabStatus (param) {
      const pager = { ...this.pagination }
      pager.current = 1
      this.SET_PAGINATION(pager)
      this.order_state = param
      this.fethOrders()
    },

    onSearch (e) {
      this.valueSearch = e.target.value
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.fethOrders()
      }, 1000)
    },

    onSerachByDate (date, dateString) {
      if (!dateString[0] || !dateString[1] || (!dateString[0] && !dateString[1])) {
        this.date.from = null
        this.date.to = null
      } else {
        this.date.from = this.changeDateFormatSearch(date[0])
        this.date.to = this.changeDateFormatSearch(date[1])
      }

      this.fethOrders()
    },

    colorStatus (param) {
      switch (param) {
        case 'draft':
        case 'waiting_payment':
          return 'blue'
        case 'new':
          return 'yellow'
        case 'on_process':
        case 'confirmed':
        case 'ready_to_pickup':
          return 'green'
        case 'sent':
          return 'purple'
        case 'delivered':
          return 'olive'
        case 'completed':
          return 'orange'
        case 'canceled':
        case 'retoured':
        case 'payment_expired':
        case 'payment_unfinish':
        case 'payment_declined':
          return 'red'
        case 'on_cancel_req':
        case 'on_retour_req':
          return 'crimson'
        default:
          break
      }
    },

    changeDateFormat (value) {
      return this.$moment(value).format('DD MMMM YYYY')
    },

    changeDateFormatInOrderDetail (value) {
      return this.$moment.unix(value / 1000).format('DD MMMM YYYY, HH:mm:ss')
    },

    changeDateFormatSearch (value) {
      return this.$moment(value).format('YYYY-MM-DD')
    },

    changeDisplayNameStatus (param) {
      // new, on_process, sent, deliverd, completed => sendiri
      // draft dan waiting_payment => jadi satu
      switch (param) {
        case 'draft':
        case 'waiting_payment':
          return 'waiting_payment'
        case 'new':
          return 'new'
        case 'on_process':
        case 'confirmed':
        case 'ready_to_pickup':
          return 'on_process'
        case 'sent':
          return 'sent'
        case 'delivered':
          return 'delivered'
        case 'completed':
          return 'completed'
        case 'canceled':
        case 'retoured':
        case 'payment_expired':
        case 'payment_unfinish':
        case 'payment_declined':
          return 'canceled'
        case 'on_cancel_req':
        case 'on_retour_req':
          return 'cancel request'
        default:
          return param
      }
    },

    showModalDetail (id, status) {
      return (e) => {
        this.position.x = window.scrollX
        this.position.y = window.scrollY

        this.$router.push({
          name: 'order.view',
          params: {
            id: id,
          },
          query: {
            ...this.$route.query,
          },
        })
      }
    },

    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.SET_PAGINATION(pager)
      this.fethOrders()
    },

    handleChangeChannels (value) {
      this.channel_id = value
      this.fethOrders()
    },
  },
  async created () {
    this.fethOrders()
    try {
      const { data: response } = await BaseURL.get('/users/private/channels')
      const addSelectAllChannel = {
        channel_id: 'all',
        channel_name: 'All Channels',
        channel_title: 'All Channels',
      }
      this.channels = [addSelectAllChannel, ...response.message]
    } catch (error) {
      //
    }
  },
}
</script>

<style lang="scss">
.order-table {
  .ant-table-row {
    cursor: pointer;
  }
}
</style>
